import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

import { GlobalSpinner } from '@maxus/website/components'
import { renderManager, uploadManager } from '@maxus/website/contexts'
import {
  useAuth,
  useDesktopAuthCallback,
  useDesktopLoginRelay,
  useFeishuApplinkPrompt,
  useLocale,
  useTicketExchange,
} from '@maxus/website/hooks'

import { AuthedPCLayout } from './layout'
import { bridge } from './lib'
import { DesktopReturnPage } from './pages/desktop-return'
import { isMobile } from './utils'

export default () => {
  useEffect(
    () => {
      const clear = bridge.initStatusRefresh()
      return () => clear()
    },
    [],
  )

  useLocale()
  useFeishuApplinkPrompt()
  // Electron 桌面壳：订阅深链接回传的登录 ticket（website 目标下为 no-op）。
  useDesktopAuthCallback()
  // 外部浏览器：桌面登录回跳（?ticket&desktop=1）时深链接回传 Electron，并渲染「返回桌面版」页。
  const { relaying } = useDesktopLoginRelay()
  const { exchanging } = useTicketExchange()

  if (relaying) return <DesktopReturnPage />
  if (exchanging) return <GlobalSpinner />

  return <Outlet />
}

export const AuthedApp = () => {
  const mobile = isMobile()
  const { i18n } = useTranslation()
  const { user } = useAuth()
  const preferenceLanguage = user?.activeBizUser?.preference?.language

  useEffect(
    () => {
      void renderManager
        .initialize()
        .catch(error => {
          console.error('[render-manager] initialization failed', error)
        })
      void uploadManager
        .initialize()
        .catch(error => {
          console.error('[upload-manager] initialization failed', error)
        })
    },
    [],
  )

  useEffect(
    () => {
      if (preferenceLanguage && preferenceLanguage !== i18n.language) {
        void i18n.changeLanguage(preferenceLanguage)
      }
    },
    [i18n, preferenceLanguage],
  )

  if (!mobile) {
    return (
      <AuthedPCLayout>
        <Outlet />
      </AuthedPCLayout>
    )
  }

  return <Outlet />
}
